import {Injectable} from '@angular/core';

@Injectable()
export class UtilsService {

  isMobileOrTablet:Boolean;

  constructor() {
    var check = false;
    (function (a) {
      if (
        a.match(/Android/i)
        || a.match(/webOS/i)
        || a.match(/iPhone/i)
        || a.match(/iPad/i)
        || a.match(/iPod/i)
        || a.match(/BlackBerry/i)
        || a.match(/Windows Phone/i)
      ) {
        check = true;
      }
    })(navigator.userAgent);
    this.isMobileOrTablet = check;
  }
}
